import {ProductImage as ProductImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {
  Button,
  COLORS,
  FONT_SIZES,
  mediaMinXXXS,
  ProductImage,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const HighTierCouponCardThumbnails = ({
  color = COLORS.Black,
  images,
  label,
}: {
  color?: string;
  images: ProductImageType[];
  label: string;
}) => {
  return (
    <ThumbnailsContainer data-testid="cardThumbnails">
      {images.map((image, index) => (
        <ThumbnailContainer key={index}>
          <ProductImage
            src={image.src}
            alt={image.description}
            padded={image.isEnclosed}
            ratio={'3:3'}
          />
        </ThumbnailContainer>
      ))}
      <StyledButton $fontColor={color} variant="secondary" size="md">
        {label}
      </StyledButton>
    </ThumbnailsContainer>
  );
};

const ThumbnailsContainer = styled.div`
  display: flex;
  width: calc(100% + 16px);
  margin-left: -8px;
  opacity: 0;
  position: absolute;
  bottom: 0;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  animation: fadeIn 0.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
`;

const ThumbnailContainer = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.Grey4};
  border-radius: 3px;
  margin-right: 6px;
`;

const StyledButton = styled(Button)<{$fontColor?: string}>`
  &&&& {
    flex: 1;
    max-width: unset;
    height: 32px;
    padding: 7px 10px;
    font-size: ${FONT_SIZES.px12};
    --color: ${({$fontColor}) => $fontColor};
  }

  @media ${mediaMinXXXS} {
    &&&& {
      font-size: ${FONT_SIZES.px14};
    }
  }
`;
